import { plugin as p } from "../../../../../../@css-render_plugin-bem@0.15.14_css-render@0.15.14/node_modules/@css-render/plugin-bem/esm/index.js";
import { CssRender as i } from "../../../../../../css-render@0.15.14/node_modules/css-render/esm/CssRender.js";
const a = "n", e = `.${a}-`, u = "__", d = "--", t = i(), c = p({
  blockPrefix: e,
  elementPrefix: u,
  modifierPrefix: d
});
t.use(c);
const {
  c: r,
  find: $
} = t, {
  cB: l,
  cE: M,
  cM: g,
  cNotM: x
} = c;
function C(o) {
  return r(({
    props: {
      bPrefix: n
    }
  }) => `${n || e}modal, ${n || e}drawer`, [o]);
}
function P(o) {
  return r(({
    props: {
      bPrefix: n
    }
  }) => `${n || e}popover`, [o]);
}
function v(o) {
  return r(({
    props: {
      bPrefix: n
    }
  }) => `&${n || e}modal`, o);
}
const B = (...o) => r(">", [l(...o)]);
function _(o, n) {
  return o + (n === "default" ? "" : n.replace(/^[a-z]/, (s) => s.toUpperCase()));
}
export {
  v as asModal,
  r as c,
  l as cB,
  B as cCB,
  M as cE,
  g as cM,
  x as cNotM,
  _ as createKey,
  $ as find,
  C as insideModal,
  P as insidePopover,
  a as namespace,
  e as prefix
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/cssr/index.js
// module id = 6
// module chunks = 41